<template>
  <div>
    <transition name="populate">
      <section v-if="ticket" class="main-hero" v-lazy:background-image="get(ticket, 'movie.m.d')" id="top">
        <div class="movieToday">
          <div class="date-nav">
          <kms-a class="prev" v-if="get(ticket, 'links.prev', false)" :to=" '/' + get(ticket, 'links.prev.uri')" :title="get(ticket, 'links.prev.title')">❮</kms-a>
          <tag v-if="get(ticket, 'fd')">{{ get(ticket, 'fd') }}</tag>
          <kms-a class="next" v-if="get(ticket, 'links.next', false)" :to=" '/' + get(ticket, 'links.next.uri')" :title="get(ticket, 'links.next.title')">❯</kms-a>
          </div>
          <h1-title color="white">{{ get(ticket, 'movie.t') }}</h1-title>
          <kms-button v-if="ticket.dt && $route.path!='/movie/'+ ticket.movie.s + '/' + dateToSlug(ticket.dt)"  :to="'/movie/'+ ticket.movie.s + '/' + dateToSlug(ticket.dt)" color="white" type="red-fill">Details Anzeigen</kms-button>
          <kms-button v-if="ticket.afp" to="https://kms.mobi/index.php?standard" color="white" :type="$route.path!='/movie/'+dateToSlug(ticket.dt) ? 'transparent':'red-fill'">Tickets kaufen</kms-button>
          <kms-button v-if="get(ticket, 'movie.tr')" :func="$refs['trailer'].open" color="white" type="transparent">Trailer abspielen</kms-button>
        </div>
      </section>
    </transition>
    <section v-if="!ticket" class="main-hero placeholder hero" id="top">
      <div class="movieToday">
        <tag class=""><dots-loader></dots-loader></tag>
        <h1-title class="" color="white"><dots-loader></dots-loader></h1-title>
        <kms-button to="" color="white" type="red-fill"><dots-loader></dots-loader></kms-button>
        <kms-button to="" color="white" type="transparent"><dots-loader></dots-loader></kms-button>
      </div>
    </section>

    <full-screen backText="Go back" ref="trailer" class="no-head-padding">
      <template v-slot:content>
        <trailer class="full-screen" :movie="get(ticket, 'movie')"></trailer>
      </template>
    </full-screen>
  </div>

</template>

<script>
import H1Title from "@/components/elements/H1Title.vue";
import KmsButton from "@/components/elements/KmsButton.vue";
import DotsLoader from "@/components/elements/DotsLoader.vue";
import FullScreen from '@/components/elements/FullScreen.vue';
import Trailer from '@/components/modules/Movie/Trailer.vue';
import Tag from "@/components/elements/Tag.vue"

import { get } from 'lodash-es'

export default {
  components: { H1Title, KmsButton, DotsLoader, FullScreen, Trailer, Tag },
  props: ["ticket"],
  data() {
    return {
      focalPoint:null,
    };
  },
  methods: {
    get: get,
    dateToSlug: function(date) {
      return date ? date.d+'/'+date.m+'/'+date.y : null;
    },
  },
  watch:{
    ticket:function(obj){
      var vm=this;
      this.$nextTick(function () {
        if(obj && get(obj, 'movie.m.hasFocalPoint')) {
          var top = document.querySelector('#top');
          top.style.backgroundPositionX = (get(obj, 'movie.m.focalPoint.x')*100)+'%';
          top.style.backgroundPositionY = (get(obj, 'movie.m.focalPoint.y')*100)+'%';
        }
      });
    }
  },
  mounted:function(){

  }
};
</script>

<style lang="scss" scoped>
@import "@/sass/_variables.scss";
@import "@/sass/_placeholder.scss";

.main-hero {
  width: 100%;
  height: 50vh;
  min-height: 50vw;
  background-position: center;
  background-size: cover;
  position: relative;
  background-color: $dark-blue-bg;
  @include for-size(phone-only) {
    height:80vh;
  }
  @include for-size(big-desktop-up) {
    height: 45vw;
    min-height: 45vw;
  }
  @include for-size(desktop-ultrawide) {
    height: 40vw;
    min-height: 40vw;
  }
  &.small {
    min-height: 40vw;
  }
  &:before {
    content: "";
    height: 100%;
    width: 100%;
    position: absolute;
    background-color: rgba(11, 24, 39, 0.15);
  }

  .movieToday {
    position: absolute;
    bottom: 25%;
    left: 10%;
    width: 80%;

    @include for-size(phone-only) {
      bottom:initial;
      top:25%;
    }
    & > span {
      position: initial;
    }
    h1 {
      margin: .15em 0 .5em 0;
      @include for-size(phone-only) {
        margin: 0.3em 0 1em 0;
        max-height: 4.5em;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      text-align: left;
      display: inline-block;
      width: 100%;
      filter:drop-shadow(1px 1px 20px rgba(0,0,0,0.5));
    }
  }


  &.placeholder {
    .movieToday {

      button {
        min-width: 9em;
        pointer-events: none;
        @include for-size(phone-only) {
          min-width: initial;
        }
      }
    }
  }
}

@keyframes bounceOutLeft {
  20% {
    transform: translate3d(20px, 0, 0);
  }

  to {
    transform: translate3d(-2000px, 0, 0);
  }
}

.bounceOutLeft {
  animation-name: bounceOutLeft;
}


@keyframes bounceInLeft {
  from,
  60%,
  75%,
  90%,
  to {
    animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
  }

  0% {
    transform: translate3d(-3000px, 0, 0);
  }

  60% {
    transform: translate3d(25px, 0, 0);
  }

  75% {
    transform: translate3d(-10px, 0, 0);
  }

  90% {
    transform: translate3d(5px, 0, 0);
  }

  to {
    transform: translate3d(0, 0, 0);
  }
}

.populate-enter-active {
  transition: opacity 0.5s;
  transition-delay: 0s;
}
.populate-enter {
  opacity: 0;
  transition-delay: 0.2s;
}

.date-nav{
  display: flex;
  align-items: center;
}

.prev,.next{
  color: white;
  filter:drop-shadow(1px 1px 20px rgba(0,0,0,0.5));
  display: inline-block;
  padding: .1em .1em;
  z-index: 3;
  width: 28px;
  text-align: center;
  cursor: pointer;
  font-size: 1.5rem;
  text-decoration: none;
  background-image: none;
  transition: none;
  @include for-size(phone-only) {
    padding: .2em .2em;
  }
}


</style>



// WEBPACK FOOTER //
// src/components/modules/Movie/MovieHero.vue